import React from "react";
import { Modal } from "../../../../../../../shared/Modal/Modal";
import { Button } from "../../../../../../../shared/Button/Button";
import { useActivateSmartReaderCellular } from "../hooks/useActivateSmartReaderCellular";
import { useDeactivateSmartReaderCellular } from "../hooks/useDeactivateSmartReaderCellular";
import { CircularProgress } from "../../../../../../../shared/CircularProgress/CircularProgress";
import { uiNotification } from "../../../../../../../services/UINotificationService";

const CellularCapabilityConfirmationModal = ({
  onClose,
  isCurrentlyActive,
  deviceId,
  refetch,
  deactivateOnNo = false,
}) => {
  const { mutate: activateCellular, isLoading: isActivating } =
    useActivateSmartReaderCellular();
  const { mutate: deactivateCellular, isLoading: isDeactivating } =
    useDeactivateSmartReaderCellular();

  const isLoading = isActivating || isDeactivating;

  const runMutation = (mutate, action) => {
    mutate(
      { pos_device_id: deviceId },
      {
        onSuccess: () => {
          onClose();
          refetch();
        },
        onError: () => {
          uiNotification.error(
            `Failed to ${action} cellular option. Please try again.`,
          );
        },
      },
    );
  };

  const handleSubmit = () => {
    if (isCurrentlyActive) {
      runMutation(deactivateCellular, "deactivate");
    } else {
      runMutation(activateCellular, "activate");
    }
  };

  const handleNo = () => {
    if (deactivateOnNo) {
      runMutation(deactivateCellular, "deactivate");
    } else {
      onClose();
    }
  };

  return (
    <Modal
      isOpen
      onClose={onClose}
      header={<h3>Confirm Action</h3>}
      footer={
        <div className="flex justify-end gap-16">
          <Button
            onClick={handleNo}
            variant="outlined"
            size="small"
            isDisabled={isLoading}
            leftAdornment={
              deactivateOnNo && isDeactivating ? (
                <CircularProgress size="small" />
              ) : null
            }
          >
            No
          </Button>
          <Button
            size="small"
            onClick={handleSubmit}
            isDisabled={isLoading}
            leftAdornment={
              isLoading ? <CircularProgress color="white" size="small" /> : null
            }
          >
            Yes
          </Button>
        </div>
      }
    >
      <p>
        Would you like to {isCurrentlyActive ? "deactivate" : "activate"}{" "}
        cellular service for this S710 device?{" "}
      </p>
      {Boolean(!isCurrentlyActive) && (
        <p>
          Cellular service is available for <b>$10/month</b>
        </p>
      )}
    </Modal>
  );
};

export default CellularCapabilityConfirmationModal;
